import React, { useEffect, useState } from "react";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { t } from "i18next";
import CoreCalendar from "../../../app/core/components/CoreCalendar/CoreCalendar";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import {
  useGetRegioniQuery,
  useGetProvinceQuery,
  useGetSediQuery,
  useGetSpotsQuery,
  useGetInfoDefaultQuery,
} from "../../api/user/openBoxApi";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { toast } from "react-toastify";
import { formatTimeRange } from "../../../utils/functions/date-utils";
import { Card, CardContent } from "@mui/material";
import {
  useBookSpazioMutation,
  useEditBookSpazioMutation,
} from "../../api/user/gestisciPraticheApi";
import { useLocation, useNavigate } from "react-router-dom";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const Reservation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    regione: "",
    provincia: "",
    servizio: location?.state?.serviceCode,
    spots: [],
  });

  const [singleEvent, setSingleEvent] = useState();
  const [idSpazio, setIdSpazio] = useState();
  const [oraBoolean, setOraBoolean] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const [showEdit, setShowEdit] = useState(false);

  const { data: getInfoDefault } = useGetInfoDefaultQuery();
  const { data: getRegioni } = useGetRegioniQuery();
  const { data: getProvince } = useGetProvinceQuery(formData?.regione, {
    skip: !formData?.regione,
  });
  const { data: getSedi } = useGetSediQuery(formData?.provincia);

  const { data: getSpots } = useGetSpotsQuery(
    { spots: formData },
    {
      skip: !formData?.sede,
    }
  );

  const [createBookSpazio] = useBookSpazioMutation();
  const [editBookSpazio] = useEditBookSpazioMutation();

  useEffect(() => {
    handlePreSetDati();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getInfoDefault]);

  useEffect(() => {
    if (getSpots && getSpots?.Data) {
      const formattedSpots = getSpots?.Data?.map((el) => ({
        date: `${el.data.slice(0, 4)}-${el.data.slice(4, 6)}-${el.data.slice(
          6,
          8
        )}T00:00:00`,

        oraDisponibile: {
          time: formatTimeRange(el.ora_Inizio, el.ora_Fine),
          value: [
            {
              ora_Inizio: el.ora_Inizio,
              ora_Fine: el.ora_Fine,
              idSpazio: el.id_Spazio,
            },
          ],
        },
      }));

      setFormData((prevFormData) => ({
        ...prevFormData,
        spots: formattedSpots,
      }));
    }
  }, [getSpots]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleOpen = (el) => {
    setSingleEvent(el.event._def.extendedProps);
  };

  const handleResetInput = () => {
    handlePreSetDati();
    setSingleEvent(null);
    setResetKey((prevKey) => prevKey + 1);
  };

  const handleSelectOra = (ora) => {
    if (!oraBoolean) {
      setIdSpazio(ora.idSpazio);
      setOraBoolean(true);
    } else {
      setIdSpazio(null);
      setOraBoolean(false);
    }
  };

  const handlePreSetDati = () => {
    if (getInfoDefault && getInfoDefault.Data) {
      setFormData({
        regione: getInfoDefault.Data.region,
        provincia: getInfoDefault.Data.province,
        servizio: location?.state?.serviceCode,
      });
    } else {
      setFormData({
        regione: "",
        provincia: "",
        servizio: location?.state?.serviceCode,
        spots: [],
      });
    }
  };

  const handleSave = async () => {
    const toastId = toast.loading(t("ProcessingBook"));

    try {
      const dataBook = {
        serviceId: location?.state?.serviceId,
      };
      if (idSpazio) dataBook.spotId = idSpazio;
      const responseCreateBook = await createBookSpazio(dataBook);
      if (responseCreateBook.data.Result !== 1) {
        toast.update(toastId, {
          render: responseCreateBook.data.Exception || t("BookNotCreated"),
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        return;
      }
      toast.update(toastId, {
        render: t("BookingCreated"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
      navigate(-1);
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("BookNotCreated"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const handleEditBook = async () => {
    const toastId = toast.loading(t("ProcessingBook"));

    try {
      const dataEditBook = {
        practiceId: location?.state?.practiceId,
        prenotazioneId: location?.state?.spotId,
        spotId: idSpazio,
      };

      const responseEditBook = await editBookSpazio({ book: dataEditBook });
      if (responseEditBook.data.Result !== 1) {
        toast.update(toastId, {
          render: responseEditBook.data.Exception || t("BookNotEdited"),
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        return;
      }
      toast.update(toastId, {
        render: t("BookingEdited"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
      navigate(-1);
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("BookNotEdited"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <div>
      <div className="w-full flex justify-center items-center py-4">
        <CoreBack />
        <div className="flex justify-between items-center w-3/4">
          <h2 className="text-center">{t("Reservation")} </h2>
          <div className="space-x-4">
            <CoreButton
              testo={"Reset"}
              className={"text-primary"}
              onClick={handleResetInput}
            />
            <CoreButton
              testo={t("Edit")}
              className={"text-statusGreen"}
              onClick={() => setShowEdit(!showEdit)}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center">
        <div
          className={
            showEdit ? "w-3/4 flex space-x-4 justify-between" : "w-3/4 flex"
          }
        >
          <div className="">
            {showEdit && (
              <Card className="rounded-xl shadow-xl w-[32rem]">
                <CardContent>
                  <h2>Selezione automatica</h2>
                  <div className="flex flex-col w-full items-center justify-between">
                    <div className="w-full">
                      <h3 className="mt-0">Regione </h3>

                      <CoreSelectObjArr
                        key={`regione-${resetKey}`}
                        name="regione"
                        label={t("Regione")}
                        value={formData?.regione}
                        items={[
                          { label: "Svuota", value: "" },
                          ...(getRegioni?.Data?.map((el) => ({
                            label: el?.descrizione,
                            value: el?.codice,
                            codice: el?.codice,
                          })) || []),
                        ]}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="w-full ">
                      <h3 className="mt-0">Provincia </h3>
                      <CoreSelectObjArr
                        key={`provincia-${resetKey}`}
                        name="provincia"
                        label={t("Provincia")}
                        value={formData?.provincia}
                        items={[
                          { label: "Svuota", value: "" },
                          ...(getProvince?.Data?.map((el) => ({
                            label: el?.descrizione,
                            value: el?.codice,
                            codice: el?.codice,
                          })) || []),
                        ]}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>

          <div className="flex flex-col w-2/4 rounded-xl shadow-xl p-8">
            <div className="">
              <h3 className="text-center">Sede </h3>

              <div className="flex flex-col">
                <CoreSelectObjArr
                  key={`sede-${resetKey}`}
                  className={"w-full"}
                  name="sede"
                  label={t("Sede")}
                  value={formData?.sede}
                  items={[
                    { label: "Svuota", value: "" },
                    ...(getSedi?.Data?.map((el) => ({
                      label: el?.descrizione,
                      value: el?.codice,
                      codice: el?.codice,
                    })) || []),
                  ]}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-3/4 space-x-4 py-4">
          <div className="p-8 w-2/3 rounded-xl shadow-xl">
            <CoreCalendar
              onOpen={handleOpen}
              events={Object.values(
                formData?.spots && formData.spots.length > 0
                  ? formData?.spots?.reduce((acc, el) => {
                      if (!acc[el.date]) {
                        acc[el.date] = {
                          title: "Disponibile",
                          date: el.date,
                          oraDisponibile: {
                            value: [],
                          },
                        };
                      }
                      acc[el.date].oraDisponibile.value.push(
                        ...el.oraDisponibile.value
                      );
                      return acc;
                    }, {})
                  : {}
              )}
            />
          </div>

          <div className="p-8 rounded-xl shadow-xl w-1/3">
            <div className="w-full h-full">
              {singleEvent ? (
                <div>
                  <h2 className="text-center">Orari disponibili</h2>
                  <div className="flex justify-center flex-wrap gap-4">
                    {Array.isArray(singleEvent?.oraDisponibile?.value) &&
                    singleEvent.oraDisponibile.value.length > 0 ? (
                      singleEvent.oraDisponibile.value.map((ora, index) => (
                        <CoreChip
                          key={index}
                          className={
                            idSpazio === ora.idSpazio &&
                            "bg-green-500 text-white"
                          }
                          variant={
                            idSpazio === ora.idSpazio ? "contained" : "outlined"
                          }
                          onClick={() => handleSelectOra(ora)}
                          label={`${ora.ora_Inizio.slice(
                            0,
                            2
                          )}:${ora.ora_Inizio.slice(2)} - ${ora.ora_Fine.slice(
                            0,
                            2
                          )}:${ora.ora_Fine.slice(2)}`}
                        />
                      ))
                    ) : (
                      <CoreChip
                        variant={
                          idSpazio === singleEvent?.oraDisponibile.idSpazio
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() =>
                          handleSelectOra(singleEvent?.oraDisponibile)
                        }
                        label={singleEvent?.oraDisponibile?.time}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center h-full ">
                  <p className="h-full flex text-xl text-center items-center text-gray">
                    Orario non disponibile
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full justify-around mt-10">
        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={location?.state?.edit ? t("Edit") : t("Save")}
          onClick={location?.state?.edit ? handleEditBook : handleSave}
          disabled={!singleEvent || !idSpazio}
        />
      </div>
    </div>
  );
};

export default Reservation;
